import type { AccordionItemData } from "@/src/components/molecules/Accordion";

export const whyChooseUsItems: AccordionItemData[] = [
  {
    title: "Intelligence at the Core of How We Build",
    content:
      "Our engineers work with OpenAI, Claude, Gemini, Llama, LangChain, LlamaIndex, Pinecone, Weaviate, and Qdrant daily in production, not in tutorials. We have deployed RAG systems, multi-agent architectures with LangGraph, vision transformers with CUDA optimization, and real-time AI streaming with WebSockets. This is not a capability we are building. It is what we do.",
  },
  {
    title: "Engineering That Supports Real Systems",
    content:
      "We do not rent out developers and disappear. Every engagement comes with a dedicated project manager, structured sprint planning, and direct access to the engineers building your product. We think about your architecture, your user experience, and your scaling challenges because we are invested in your product succeeding - not just in billing hours.",
  },
  {
    title: "95% of Our Clients Are SaaS Founders",
    content:
      "This means every engineer on our team has deep context in SaaS patterns: multi-tenancy, subscription billing, role-based access, API design, webhook integrations, and the specific scaling challenges that SaaS products face. You do not need to explain what a webhook is. You do not need to explain why tenant isolation matters. We already know. That's why startup founders across the US, UK, and UAE choose TechEniac as their long-term product engineering partner.",
  },
  {
    title: "Long-Term Partnerships, Not One-Off Projects",
    content:
      "We are not optimized for one-off projects. Our business model is built on long-term partnerships with founders who keep building. When your MVP succeeds and you need to scale, we are already there, with full context on your codebase, your architecture decisions, and your product roadmap.",
  },
];
